
import style from './aboutUs.module.scss';
import Head from 'next/head';
import Image from 'next/image';
import { useEffect, useState } from 'react';


function AboutUs(props) {

  //Handle media query checks
  const [mediaSize, setMediaSize] = useState(true)
  useEffect (() => {
    const checkMediaSize = () => {
      window.matchMedia("(max-width: 700px)").matches ? setMediaSize(true) : setMediaSize(false) 
    }

    checkMediaSize()
  })

  //check whether to render webp or png
  let imageType = "png"
  if (props.webp === "webp") {
    imageType = "webp"
  }

  let officeImg = null

  if (props.windowSize === "Web") {
    officeImg = <Image 
      src={"/Assets/Images/Office_with_styling_AU." + imageType}
      alt="Office with styling AU"
      layout="fill"
      objectFit="contain"
      priority
    />
  } else {
    officeImg = <Image 
      src={"/Assets/Images/E2_Office." + imageType}
      alt="Basler Services office"
      layout="fill"
      objectFit="cover"
      priority
    />
  }

  const forklift = <div className={style.forklift}>
    <Image 
      src={"/Assets/Images/Tech_forklift_cabinet." + imageType}
      alt="Tech on forklift lifting cabinet"
      layout="fill"
      objectFit="cover"
    />
  </div>
  const engineer = <div className={style.engineer}>
    <Image 
      src={"/Assets/Images/engineer_working_on_systems." + imageType}
      alt="Engineer working on systems"
      layout="fill"
      objectFit="cover"
    />
  </div>
  return (
    <div className={style.AboutUs}>
      <Head>
        <title>About Us | Basler Services</title>
			</Head>

      <div className={style.history}>
        <h1>About Us</h1>
        <h2>Company History</h2>
        <div className={style.auGrid}>
          <div className={style.auLeftCell}>
            <p>Basler Services, LLC, formerly E&#178; Power Systems, was acquired in 2017 by Basler Electric to better meet customers&#39; needs by offering seamless solutions for both product and engineering services. The combination of experience and customer focus of E&#178; enhanced Basler&#39;s ability to provide outstanding technical support, product and engineering services to its customers.</p>
            <p>In 2021, we acquired SEGRITY, LLC, a company specializing in hydro governors, unit and plant controls, control systems installation and commissioning. This addition helps us better serve our hydro power customers with more comprehensive solutions.</p>
            <div className={style.logoContainer}>
              <img className={style.baslerLogo} alt="Basler Logo" src={'/Assets/Images/Basler_Logo.' + imageType} />  
            </div>
            <div className={style.logoContainer}>
              <img className={style.baslerLogo} alt="E2 Logo" src={'/Assets/Images/E2PS_Logo.' + imageType} /> 
              <img className={style.baslerLogo} alt="SEGRITY Logo" src={'/Assets/Images/SEGRITY_Logo.' + imageType} /> 
            </div> 
            <p>We are a leading full-service electrical engineering and field services company, recognized for our knowledge, superior work and excellent customer service. Our engineers and technicians have broad systems and equipment knowledge, giving them the unique ability to provide excellent service for your project, no matter the size.</p>
          </div>
          <div className={style.auRightCell}>
            {officeImg}
          </div>
        </div>
      </div>
      <div className={style.whatWeProvide}>
        <h1>What We Provide</h1>
        <h2>What Sets Us Apart?</h2>
        <div className={style.wwpGrid}>
          <div className={style.wwpLeftCell}>
            <div>
              <h4>Our Knowledge</h4>
              <span></span>
              <p>With extensive knowledge in systems ranging from older installations to state‐of‐the‐art applications, we have the unique ability to identify and understand all aspects of systems whether in a new installation or as part of a retrofitted system.</p>
            </div>
            {props.windowSize !== "Web" && mediaSize ? forklift : ""}
            <div>
              <h4>Our Experience</h4>
              <span></span>
              <p>Our staff includes electrical engineers, master electricians, AutoCAD designers and other technical and support staff who bring over 150 years of combined education, design and specific field experience to each project. Our customers include government entities, and heavy and light industries from all over the world.</p>
            </div>
            {props.windowSize !== "Web" && mediaSize ? engineer : ""}
            <div>
              <h4>Our Solutions</h4>
              <span></span>
              <p>Independent of any single supplier or manufacturer, Basler Services, LLC is able to supply all services from initial feasibility study and design, equipment specification and procurement through installation, and commissioning. Once your system is fully integrated we provide ongoing support through technical training, NERC compliance services, system studies, maintenance and troubleshooting.</p>
            </div>
          </div>
          {mediaSize === false ? forklift : ""}
          {mediaSize === false ? engineer : ""}
        </div>
      </div>
    </div>
  );
}

export default AboutUs;